import React from 'react'
import { arrowIcon, articleArrowIcon } from '../../../images/icon'

export default ({className, to, onClick ,isArticlePage}) => (
  <button aria-label={to} type="button" onClick={onClick} className={`button button--text button--icon ${className}`}>
    {isArticlePage ? articleArrowIcon()  : arrowIcon()}
  </button>
)